import { api, getData, postData } from './request';
import type { Conversation } from '@cutr/constants/order';
import type {
  ConversationLabel,
  ConversationProvider,
} from '@cutr/constants/conversations';

export type ConversationRow = Omit<
  Conversation,
  'messages' | 'audits' | 'calls' | 'statusEvents'
>;

export type ConversationDetail = Conversation;
export type ConversationSummary = ConversationRow;

export type CreateConversationPayload = {
  orderId: string;
  providerType: ConversationProvider;
  makerOrganisationId?: string;
  customerOrganisationId?: string;
};

export function getConversation(
  conversationId: string,
  { includeMessages }: { includeMessages: boolean },
  signal?: AbortSignal
) {
  return getData<Conversation>(`/v2/conversations/${conversationId}`, {
    params: { includeMessages },
    signal,
  });
}

export function getOrderConversations(orderId: string, signal?: AbortSignal) {
  return getData<ConversationRow[]>(`/v2/orders/${orderId}/conversations`, {
    signal,
  });
}

export function sendConversationMessage(
  conversationId: string,
  data: FormData
) {
  return postData<ConversationRow>(
    `/v2/conversations/${conversationId}/messages`,
    data,
    { headers: { 'Content-Type': 'multipart/form-data' } }
  );
}

export function createConversation(payload: CreateConversationPayload) {
  return postData<ConversationRow>('/v2/conversations', payload);
}

export async function markConversationViewed(conversationId: string) {
  await api.post(`/v2/conversations/${conversationId}/viewed`);
}

export async function setMessageLabels(
  conversationId: string,
  payload: { providerMessageId: string; labels: ConversationLabel[] }
) {
  await api.post(`/v2/conversations/${conversationId}/labels`, payload);
}

export async function deleteConversation(conversationId: string) {
  await api.delete(`/v2/conversations/${conversationId}`);
}
